import { StrictMode } from 'react';

import { RouterProvider, createRouter } from '@tanstack/react-router';
import ReactDOM from 'react-dom/client';

import { TooltipProvider } from '@components/ui/tooltip.tsx';
import { useAuth } from '@contexts/auth/index.ts';
import { AuthProvider } from '@contexts/auth/provider.tsx';
import { Redirect } from '@services/_httpClient/Redirect/index.tsx';

import * as TanStackQueryProvider from './integrations/tanstack-query/root-provider.tsx';
import reportWebVitals from './reportWebVitals.ts';
// Import the generated route tree
import { routeTree } from './routeTree.gen';

import './styles.css';

// Create a new router instance

const TanStackQueryProviderContext = TanStackQueryProvider.getContext();
export const router = createRouter({
  routeTree,
  defaultPreload: false,
  context: {
    ...TanStackQueryProviderContext,
    auth: {
      user: null,
      authorization: {
        refreshToken: null,
        token: null,
      },
    },
  },
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById('app');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <TanStackQueryProvider.Provider {...TanStackQueryProviderContext}>
        <AuthProvider>
          <TooltipProvider>
            <App />
          </TooltipProvider>
          <Redirect />
        </AuthProvider>
      </TanStackQueryProvider.Provider>
    </StrictMode>,
  );
}

function App() {
  const auth = useAuth();
  return <RouterProvider context={{ auth }} router={router} />;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
